module.exports = __webpack_public_path__ + "static/media/avatar.f1c35b27.svg";